import { ChangeDetectorRef, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { AuthService } from '../../services/auth.service';
import { EnvironmentService } from 'app/core/services/environment.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OktaService } from 'app/core/services/okta.service';
declare var OktaAuth: any;

@Component({
  selector: 'itpx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  private referrer: string;
  public logo: string;
  public year: number;
  private domainConfigData;

  protected form: FormGroup

  public loading = false;
  public error: string;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private authService: AuthService,
    private renderer: Renderer2,
    private environmentService: EnvironmentService,
    private fb: FormBuilder,
    private readonly oktaService: OktaService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.referrer = this.route.snapshot.queryParams['referrer'];
    this.utilService.hidePartials();
    this.setBackground();
    this.year = new Date().getFullYear();
    this.logo = this.configService.get('aws').downloadUrl + this.configService.get('images').newColorEdcastLogo;

    this.form = this.fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required]
  });
  }

  ngOnDestroy() {
    this.utilService.showPartials();
    this.removeBackground();
  }

  createBuyerAccount() {
    const queryParams = {};
    if (this.referrer) queryParams['referrer'] = this.referrer;

    this.router.navigate(['/register'], { queryParams: queryParams });
  }

  createSellerAccount() {
    const queryParams = {};
    if (this.referrer) queryParams['referrer'] = this.referrer;

    this.router.navigate(['/register/seller'], { queryParams: queryParams });
  }

  setBackground() {
    this.renderer.setStyle(document.body, 'background-color', '#f7f7f7');
  }

  removeBackground() {
      this.renderer.removeStyle(document.body, 'background-color');
  }

  onLoginSubmit() {
      for (const i in this.form.controls) {
        if (Object.prototype.hasOwnProperty.call(this.form.controls, i)) {
          this.form.controls[i].markAsDirty();
          this.form.controls[i].updateValueAndValidity();
        }
      }
  
      if (this.form.valid) {
        this.login(this.form.value);
      }
  }

  public async login(payload: any): Promise<void> {
    this.loading = true;
    // //TODO: Remove domain
    payload.username = `${this.configService.get('okta').prefix}-${payload.username}`;
    try {
      const transaction = await this.oktaService.oktaClient.signInWithCredentials(payload);
      if (transaction.status !== 'SUCCESS') {
        throw Error(`Authentication error occurred with status: ${transaction.status}`);
      }
      await this.oktaService.oktaClient.token.getWithRedirect({
        sessionToken: transaction.sessionToken,
        responseType: 'id_token',
      });
    } catch (e) {
      this.error = 'Username and password you have provided do not match';
    }

    // this.loading = false;
    // this.cdr.markForCheck();
  }

  sagaRedirect() {
    return new Promise((resolve, reject) => {
      const url = this.configService.get('saga').url;
      window.location.href = url;
    });
  }

  forgotPasswordRedirect() {
    const url = `${this.configService.get('server').account}/forgot-password`;
    window.open(url, "_blank");
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/login/login.component.ts